// LEGACY: Uses @ion/components. New code should use @metarouter-private/mr-mui components instead.
import React, { createContext, useContext } from 'react';
import propTypes from 'prop-types';
import { useOpen } from '@ion/components';
import { usePipelinePageContext } from 'app/pipeline-details/PipelinePageContextProvider';
import useInputEventState from './useInputEventState';
import useEventValidation from './useEventValidation';
import buildOnInputEventChange from './buildOnInputEventChange';
import usePipelineIntegrationSelect from './usePipelineIntegrationSelect';
import useTestPipelineChainState from './useTestPipelineChainState';

const TestPipelineDrawerContext = createContext(null);

export default function TestPipelineDrawerContextProvider({ children }) {
  const [isOpen, onOpen, onClose] = useOpen();
  const { inputEvent, parsedInputEvent, setInputEvent } = useInputEventState();
  const { pipeline } = usePipelinePageContext();
  const { setIsValidJson, hasValidInputEvent, validatingEvent, validationError, validate } = useEventValidation({
    clusterId: pipeline.cluster.id,
  });

  const { selectedPipelineIntegrationId, onSelectPipelineIntegration, selectedPipelineIntegration } =
    usePipelineIntegrationSelect();

  const chainState = useTestPipelineChainState({
    parsedInputEvent,
    hasValidInputEvent,
    validatingEvent,
    pipelineIntegration: selectedPipelineIntegration,
  });

  const onInputEventChange = buildOnInputEventChange({ inputEvent, setInputEvent, chainState, validate });

  const onSelectPipelineIntegrationWrapper = event => {
    onSelectPipelineIntegration(event);
    chainState.onPipelineIntegrationChange();
  };

  const value = {
    state: {
      inputEvent,
      onInputEventChange,
      selectedPipelineIntegrationId,
      onSelectPipelineIntegration: onSelectPipelineIntegrationWrapper,
      selectedPipelineIntegration,
      hasValidInputEvent,
      setIsValidJson,
      validatingEvent,
      validationError,
      chainState,
    },
    drawer: {
      open: isOpen,
      onOpen,
      onClose,
    },
  };

  return <TestPipelineDrawerContext.Provider value={value}>{children}</TestPipelineDrawerContext.Provider>;
}

export function useTestPipelineDrawerContext() {
  return useContext(TestPipelineDrawerContext);
}

TestPipelineDrawerContextProvider.propTypes = {
  children: propTypes.node.isRequired,
};
